import { nanoid } from 'nanoid';

export const idGenerator = (label = 'component') => {
  const id = `${label}-${nanoid()}`;

  return id;
};
